module.exports = __webpack_public_path__ + "img/menu_show.9b70c828.svg";